import React, { useState, useEffect } from "react";
import TweetBox from "../TweetBox";
import Post from "../Post";
import axios from "axios";
import { CircularProgress } from "@material-ui/core";
import { API_URL } from "./config";
import Layout from "./Layout";
import auth from "./Auth/auth";
function HomePage(props) {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const updatePost = (new_post) => {
    setPosts([...[new_post], ...posts]);
  };
  const headers = auth.getHeaders();
  const fetchPosts = () => {
    setIsLoading(true);

    // console.log(headers);
    // return false;
    axios
      .post(
        `${API_URL}/home`,
        {
          offset: posts.length,
        },
        { headers }
      )
      .then(function (response) {
        setIsLoading(false);
        setPosts([...posts, ...response.data.data.posts]);
      })
      .catch(function (error) {
        //console.log(error);
      });
  };
  useEffect(() => {
    fetchPosts();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const loadMore = () => {
    fetchPosts();
  };
  return (
    <Layout headerTitle='Home' {...props}>
      <TweetBox
        postAppend={(post) => {
          updatePost(post);
        }}
      />
      {posts.map((post, index) => {
        const {
          id,
          user_image,
          user_name,
          title,
          details,
          images,
          verified,
          created_at,
          slug,
          check_if_follows_count,
          followers_count,
        } = post;

        return (
          <Post
            id={id}
            key={index}
            avatar={user_image}
            username={user_name}
            title={title}
            details={details}
            image={images}
            verified={verified}
            created_at={created_at}
            slug={slug}
            check_if_follows_count={check_if_follows_count}
            followers_count={followers_count}
          />
        );
      })}
      <div className='spinner-loading'>{isLoading && <CircularProgress />}</div>
      <div className='load-more'>
        <button onClick={loadMore}> Load More</button>
      </div>
    </Layout>
  );
}

export default HomePage;
